import React, { useEffect, useState } from 'react';
import styles from "./waiting.module.scss";
import Lottie from "lottie-react";
import ContactLoader from "../styles/images/connecting.json";
import { Button, Modal } from 'antd';
import store from '../store/redux-store/root_store';
import { initialStateModel } from '../base/models/meetModal';
import { useSelector } from 'react-redux';
import {videoCallService} from '../base/service/videoCallService';
import { sipCallEnd } from '../base/video_common';
export const Waiting = () => {
  const videoMeetState: initialStateModel = useSelector((state: initialStateModel) => state);
const {announcementMsg}=store.getState().meetingReducer;
const [endModal,setEndModal]=useState(false);

useEffect(()=>{
},[JSON.stringify(videoMeetState.meetingReducer)])

  const leaveButton=()=>{
      sipCallEnd();
      videoCallService.endMeeting('endall');
    }

    const openEndModal=()=>{
      setEndModal(true);
    }

    const closeEndModal=()=>{
      setEndModal(false);
    }

    

  return (<>
  
    <div className={styles.waitingConsec}>
      <div className={styles.meetingInfoPopup}>
      
        <Lottie width={80} height={ 80} className="svgLoadingConnectg forchatsvg"
          animationData={ContactLoader} />
        <p className={styles.meetingTitleText}>Waiting …</p>
        <h3>{announcementMsg}</h3>

        <div className={styles.leaveBtn}>
            <Button className={styles.endbutton} onClick={()=> openEndModal()}>Leave</Button> </div>
      </div>
      <div className={styles.footerbottomsec}>
        <div className={`${styles.meetingscreens} ${styles.waitingroomers}`}>
          <div className={styles.mainsection}></div>
          <div className={styles.bottomsection}>
            <div className={`${styles.sectionlist} ${styles.one}`}>
              <div className={styles.listfiles}>
                <ul className={styles.lists}>
                  <li><span className="icon_meet_footer_caption"></span></li>
                  <li><span className="icon_meet_footer_virtual_bg"></span></li>
                  <li><span className="icon_meet_footer_raise_hand"></span></li>
                </ul>
              </div>
            </div>
            <div className={`${styles.sectionlist} ${styles.two}`}>
              <div className={`${styles.listfiles} ${styles.hoverlistfiles}`}>
                <ul className={styles.lists}>
                  <li><span className="icon_Audio-on-large"></span><b>Mute</b></li>
                  <li className={styles.pophoverlists}>
                    <span className="icon_Video-on">
                    </span><span className={`icon_msg_error ${styles.errormd}`}></span><b>Start Video</b>
                  </li>
                  <li><span className="icon_Share"></span><b>Share Screen</b></li>
                </ul>
              </div>
            </div>
            <div className={`${styles.sectionlist} ${styles.three}`}>
              <div className={`${styles.listfiles} ${styles.endlistfiles}`}>
                <ul className={styles.lists}>
                  <li><span className="icon_meet_footer_chat"></span></li>
                  <li><span className="icon_meet_footer_participant"></span></li>
                  <li><span className="icon_meet_footer_settings"></span></li>
                </ul>
              </div>
              {/* <Button className={styles.endbutton}>Leave Meeting</Button> */}
            </div>
          </div>
        </div>
      </div>
      <Modal open={endModal} title={<><span>End Meeting</span></>}
        centered className="customModal sizessmall autocallmodal"
        closeIcon={<span className="icon__Close16" onClick={closeEndModal}> </span>}
        footer={[
          <Button className="buttonCancel"
            onClick={closeEndModal}
          >
            Cancel
          </Button>,
          <Button type="primary" className="buttonSave deletebtn"
            onClick={leaveButton}
          >
            Yes, End Meeting
          </Button>,
        ]}>
        <p>Are you sure, you want to end this meeting?</p>
      </Modal>
    </div>
  </>);
};